<!-- Graduate Study Preference - 申请意向 -->
<template>
  <div class="info-preference">
    <h1>Graduate Study Preference</h1>
    <div class="dis-48">
      <div class="dis-12">1.What level of study (Masters, PhD, or both) are you applying to?</div>
      <div>{{info.applyLevel}}</div>
    </div>
    <div class="dis-48">
      <div class="dis-12">2. What are your primary motives for pursuing graduate studies abroad?</div>
      <div>
        <pre>{{info.studyAbroadReasons}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">3.What are your intended majors and why? (pick1-2 intended majors according to your interests)</div>
      <div>
        <pre>{{info.priorityApplyFieldAndReasons}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">4.If you intend to switch your current major to a different field of study, why do you choose to do so (if applicable)?</div>
      <div>
        <pre>{{info.changeMajorReasons}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">5.Please provide your detailed preference on school selection, i.e. location (any specific cities?), weather, tuition, rankings, etc.</div>
      <div>
        <pre>{{info.choosingCollegePreference}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">6. What are your near-term goals upon completion of your graduate program?</div>
      <div>
        <pre>{{info.nearTermObjectives}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">7.What are your long-term goals, as well as areas of professional/career interest?</div>
      <div>
        <pre>{{info.longTermObjectives}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">8.Who (or what) inspired you to set your current goals?</div>
      <div>
        <pre>{{info.objectivesSource}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">9.What is your intended time of enrollment？</div>
      <div>{{info.enrolYear}}</div>
    </div>
    <div class="dis-48">
      <div class="dis-12">10.What are the key experiences you have undertaken to prepare for graduate studies? Please summarize. (You may elaborate on your response in another questionnaire, "Past Experience")</div>
      <div>
        <pre>{{info.enrolPrepared}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">11. Potential Letter of Recommendation references - who are you thinking of asking?</div>
      <div v-for="(item,index) in info.referrals" :key="index">
        <ul class="ul-item dis-48">
          <li>
            <div>Name</div>
            <div>{{item.referralsName}}</div>
          </li>
          <li>
            <div>Title</div>
            <div>{{info.referralsTitle}}</div>
          </li>
          <li>
            <div>How you know him/her</div>
            <div>{{info.referralsKnow}}</div>
          </li>
          <li>
            <div>How well you known him/her</div>
            <div>{{info.referralsFamiliarity}}</div>
          </li>
        </ul>
      </div>

    </div>
    <div class="dis-48">
      <div class="dis-12">12. If you are to apply for a program that is different from your undergraduate major, please list all major-related courses（optional)</div>
      <div v-for="(item,index) in info.correlatedCurriculum" :key="index">
        <ul class="ul-item dis-48">
          <li>
            <div>Major-related courses</div>
            <div>{{item}}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { infoQueryApplypurpose } from '@/api/mentee'
export default {
  name: 'mentee-info-preference',
  components: {},
  data () {
    return {
      info: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo(0)
  },
  methods: {
    getInfo () {
      let param = {
        num: this.$route.params.id
      }
      infoQueryApplypurpose(param).then(res => {
        let data = res.data.model || {}
        this.info = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
